export const additionalStatuses = {
	REV_ITO: 1,
	REV_COMPANY: 2,
	ACCEPTED: 3,
	CANCEL_REQUEST: 4,
	CANCELLED: 5,
	NO_AGREEMENT: 6
};

export const additionalPaymentStatuses = {
	REQUESTED: 1,
	ITO_OBSERVED: 2,
	CONST_OBSERVED: 3,
	APPROVED: 4,
	CANCELLED: 5,
	REJECTED: 6,
	PAYED: 7,
	MODIFIED: 8
};

export default additionalStatuses;
